import { createLightTheme, themeToTokensObject } from '@fluentui/react-components';

const primary = {
    '0': '#f0faf7',
    '50': '#e0f5ee',
    '100': '#caede1',
    '200': '#a7e2cd',
    '300': '#7CD9B5',
    '400': '#49C297',
    '500': '#24a67d',
    '600': '#158664',
    '700': '#0f664f',
    '800': '#0f493a',
    '900': '#0f382d',
    '950': '#0f221e',
};

const secondary = {
    '0': '#f6f6f8',
    '50': '#dfdfe7',
    '100': '#cdcdda',
    '200': '#b6b6c8',
    '300': '#9c9cb5',
    '400': '#7c7c9d',
    '500': '#6b6b8f',
    '600': '#575775',
    '700': '#4b4b64',
    '800': '#39394c',
    '900': '#2a2a37',
    '950': '#1c1c26',
};

const info = {
    '0': '#ebf7fa',
    '50': '#d0e9f1',
    '100': '#b8dcea',
    '500': '#3493A9',
    '600': '#237A90',
    '800': '#1e4e5f',
};

const warning = {
    '0': '#fffcf0',
    '100': '#FBF3AD',
    '500': '#efb700',
    '700': '#ac6a06',
};

const error = {
    '0': '#fdf2f3',
    '100': '#F7CACA',
    '600': '#C43B4D',
    '800': '#832a32',
};

const neutral = {
    '0': '#ffffff',
    '50': '#ececee',
    '100': '#e4e2e9',
    '200': '#cdcdd6',
    '900': '#212127',
    '950': '#131316',
};

const baseTheme = createLightTheme({
    10: secondary[950],
    20: secondary[950],
    30: secondary[900],
    40: secondary[900],
    50: secondary[800],
    60: secondary[800],
    70: secondary[700],
    80: secondary[700],
    90: secondary[600],
    100: secondary[600],
    110: secondary[500],
    120: secondary[500],
    130: secondary[400],
    140: secondary[400],
    150: secondary[300],
    160: secondary[300],
});

export const theme = {
    ...baseTheme,

    fontFamilyBase: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSizeBase400: '14px',
    fontSizeBase500: '16px',
    fontSizeBase600: '20px',

    colorNeutralForeground1: secondary[700],
    colorNeutralForeground2: secondary[700],
    colorNeutralForeground3: '#5d5d73',

    colorNeutralStroke1: neutral[200],
    colorNeutralStroke2: neutral[100],

    colorBrandForeground1: secondary[700],
    colorBrandBackground: primary[600],
    colorBrandBackgroundHover: primary[800],
    colorBrandBackgroundPressed: primary[800],
    colorBrandBackgroundSelected: primary[800],

    customPaletteBlack: neutral[900],

    customPaletteGreen: primary[600],
    customPaletteGreenLight: primary[100],
    customPaletteGreenDark: primary[800],
    customPaletteGreenBackground: primary[0],

    customPaletteBlue: info[600],
    customPaletteBlueDark: info[800],
    customPaletteBlueLight: info[100],
    customPaletteBlueBackground: info[0],

    customPaletteYellow: warning[500],
    customPaletteYellowDark: warning[700],
    customPaletteYellowLight: warning[100],
    customPaletteYellowBackground: warning[0],

    customPaletteRed: error[600],
    customPaletteRedDark: error[800],
    customPaletteRedLight: error[100],
    customPaletteRedBackground: error[0],

    colorNeutralBackground6: neutral[50],
    colorStrokeFocus2: primary[600],
};

export const tokens = themeToTokensObject(theme);
